module.exports = __webpack_public_path__ + "static/media/browserbase.646a72b6.png";